import { render, staticRenderFns } from "./LibraryArticleList.vue?vue&type=template&id=9088a0fc&scoped=true&"
import script from "./LibraryArticleList.vue?vue&type=script&lang=ts&"
export * from "./LibraryArticleList.vue?vue&type=script&lang=ts&"
import style0 from "./LibraryArticleList.vue?vue&type=style&index=0&id=9088a0fc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9088a0fc",
  null
  
)

export default component.exports